export enum Channel {
  MENTIONS = 'mentions',
  SHARING = 'sharing',
  INBOX = 'inbox',
  SUBSCRIBE = 'subscribe',
}
